import React, { FC } from 'react';
import { ActionModal } from '../action-modal';
import style from './style.module.less';
import { useTranslation } from 'react-i18next';

interface RequestPrivateInfoModalProps {
  isOpenRequestModal: boolean;
  closeRequestModal: () => void;
  onConfirmRequest: () => void;
}

export const RequestPrivateInfoModal: FC<RequestPrivateInfoModalProps> = (
  props
) => {
  const { isOpenRequestModal, closeRequestModal, onConfirmRequest } = props;
  const { t } = useTranslation();
  return (
    <ActionModal
      isOpen={isOpenRequestModal}
      onClose={closeRequestModal}
      title={t('lawyer.request-private-info.header')}
      confirm={{
        text: 'Send',
        onClick: onConfirmRequest,
      }}
    >
      {t('lawyer.request-private-info.description')}
    </ActionModal>
  );
};

export const enum RequestPrivateInfoState {
  REQUEST = 'request',
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  HIDE = 'hide',
}

interface RequestPrivateInfoLinkProps {
  state: RequestPrivateInfoState;
  openRequestModal: () => void;
  openInfoModal?: () => void;
  className?: string;
  'data-onboarding-id'?: string;
  'data-onboarding-position'?: string;
}

export const RequestPrivateInfoLink: FC<RequestPrivateInfoLinkProps> = (
  props
) => {
  const { state, openRequestModal, className, openInfoModal } = props;
  const { t } = useTranslation();
  if (state === RequestPrivateInfoState.HIDE) {
    return null;
  } else if (state === RequestPrivateInfoState.PENDING) {
    return <div className={style.requestPending}>
      {t('lawyer.request-private-info.pending')}
    </div>;
  } else if (state === RequestPrivateInfoState.REQUEST) {
    return (
      <div
        onClick={openRequestModal}
        className={`${style.requestInfoLink} ${className ?? ''}`}
        data-onboarding-id={props['data-onboarding-id']}
        data-onboarding-position={props['data-onboarding-position']}
      >
        {t('lawyer.request-private-info.title')}
      </div>
    );
  } else if (state === RequestPrivateInfoState.ACCEPTED) {
    return (
      <div
        className={style.requestInfoLink}
        onClick={openInfoModal ? openInfoModal : () => {}}
        data-onboarding-id={props['data-onboarding-id']}
        data-onboarding-position={props['data-onboarding-position']}
      >
        {t('lawyer.view-information.title')}
      </div>
    );
  }
};
